var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { dateFns } from '@lhb/func';
var VersionAuthCountDownModal = /** @class */ (function (_super) {
    __extends(VersionAuthCountDownModal, _super);
    function VersionAuthCountDownModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.timer = null; // 获取数据的定时器
        _this.HH = '';
        _this.MM = '';
        _this.DD = '';
        return _this;
    }
    VersionAuthCountDownModal.prototype.dataChange = function () {
        this.value && this.setIntervalOfficialLastDays();
    };
    VersionAuthCountDownModal.prototype.beforeDestroy = function () {
        this.clearTimer();
    };
    Object.defineProperty(VersionAuthCountDownModal.prototype, "officialLastDays", {
        /**
         * 剩余天数
         */
        get: function () {
            if (!this.data || !this.data.end)
                return null;
            /**
             * 计算两个时间差值，向上取整，包括当天
             */
            return Math.ceil(dayjs(this.data.end).diff(dayjs(), 'day', true)) + 1; // 加上当天 1
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VersionAuthCountDownModal.prototype, "isBusiness", {
        get: function () {
            return this.data.versionType === 'REQUIREMENT';
        },
        enumerable: false,
        configurable: true
    });
    /* method */
    /**
     * 设置正式版倒计时
     */
    VersionAuthCountDownModal.prototype.setIntervalOfficialLastDays = function () {
        var _this = this;
        this.clearTimer();
        /**
         * 如果两个时间等于1天，说明要倒计时了
         */
        if (this.officialLastDays === 1) {
            this.timer = setInterval(function () {
                console.log(333333333);
                var timestamp = dayjs(_this.data.end).add(1, 'day').diff(dayjs());
                var hh = dateFns.doubleDigit(Math.floor(timestamp / 1000 / 60 / 60));
                var mm = dateFns.doubleDigit(Math.floor((timestamp - hh * 1000 * 60 * 60) / 1000 / 60));
                var dd = dateFns.doubleDigit(Math.floor((timestamp - hh * 1000 * 60 * 60 - mm * 1000 * 60) / 1000));
                _this.HH = hh;
                _this.MM = mm;
                _this.DD = dd;
            }, 1000);
        }
        else {
            this.HH = '';
            this.MM = '';
            this.DD = '';
        }
    };
    // 清除计时器
    VersionAuthCountDownModal.prototype.clearTimer = function () {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    };
    VersionAuthCountDownModal.prototype.confirm = function () {
        this.$emit('input', false);
        this.$emit('change', false);
        this.clearTimer();
    };
    __decorate([
        Prop({
            type: Object,
            default: function () { },
        })
    ], VersionAuthCountDownModal.prototype, "data", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], VersionAuthCountDownModal.prototype, "value", void 0);
    __decorate([
        Watch('data', {
            deep: true,
            immediate: true,
        })
    ], VersionAuthCountDownModal.prototype, "dataChange", null);
    VersionAuthCountDownModal = __decorate([
        Component({
            components: {}
        })
    ], VersionAuthCountDownModal);
    return VersionAuthCountDownModal;
}(Vue));
export default VersionAuthCountDownModal;
